import { NextResponse } from "next/server";
import axios from "axios";

export async function POST(req) {
  try {    
    const { accessToken } = await req.json();    

    const response = await axios.get("https://open.tiktokapis.com/v2/user/info",{
        params: {
          fields: "follower_count",
        },
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });

    return NextResponse.json({ data: response.data });
  } catch (error) {
    console.error("Error during getting youtube data:", error.response ? error.response.data : error.message);
    return NextResponse.json(
      { error: "Youtube data retrieve failed", details: error.response ? error.response.data : error.message },
      { status: 500 }
    );
  }
}
